"use client"

import { useState } from "react"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { GoonfolioTab } from "@/components/goonfolio/GoonfolioTab"
import { useAuthStore } from "@/lib/auth-store"
import { FavoritesBrowser } from "@/components/favorites-browser"
import { useTranslations } from "next-intl"

interface LibraryBrowserProps {
  onBack?: () => void
  onOpenEditors?: () => void
}

export function LibraryBrowser({ onBack, onOpenEditors }: LibraryBrowserProps) {
  const t = useTranslations("libraryBrowser")
  const [activeTab, setActiveTab] = useState("collections")
  const { user } = useAuthStore()

  return (
    <div className="w-full">
      <Tabs value={activeTab} onValueChange={setActiveTab} className="flex flex-col">
        <TabsList className="glass-strong border-b border-border/50 rounded-none w-full justify-start h-auto p-0 sticky top-0 z-10">
          <TabsTrigger value="collections" className="rounded-none border-b-2 data-[state=active]:border-accent">
            {t("goonfolio")}
          </TabsTrigger>
          <TabsTrigger value="favorites" className="rounded-none border-b-2 data-[state=active]:border-accent">
            {t("favorites")}
          </TabsTrigger>
        </TabsList>

        <TabsContent value="collections" className="p-4">
          {user ? (
            <GoonfolioTab profileUserId={user.id} isOwnProfile={true} />
          ) : (
            <p className="text-center text-muted-foreground py-12">{t("signInToSeeYourGoonfolio")}</p>
          )}
        </TabsContent>

        <TabsContent value="favorites">
          <FavoritesBrowser onOpenEditors={onOpenEditors} />
        </TabsContent>
      </Tabs>
    </div>
  )
}
